/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindFeatureFlagsQueryResponse } from "../types/FindFeatureFlags.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findFeatureFlagsQueryKey = () =>
  [{ url: "/v1/feature-flags" }] as const

export type FindFeatureFlagsQueryKey = ReturnType<
  typeof findFeatureFlagsQueryKey
>

/**
 * {@link /v1/feature-flags}
 */
export async function findFeatureFlags(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindFeatureFlagsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/feature-flags`, ...requestConfig })
  return res
}

export function findFeatureFlagsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findFeatureFlagsQueryKey()
  return queryOptions<
    ResponseConfig<FindFeatureFlagsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindFeatureFlagsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findFeatureFlags({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * {@link /v1/feature-flags}
 */
export function useFindFeatureFlags<
  TData = ResponseConfig<FindFeatureFlagsQueryResponse>,
  TQueryData = ResponseConfig<FindFeatureFlagsQueryResponse>,
  TQueryKey extends QueryKey = FindFeatureFlagsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindFeatureFlagsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findFeatureFlagsQueryKey()

  const query = useQuery(
    {
      ...findFeatureFlagsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
